import React from 'react';
import { MDBRow, MDBCol, MDBCard, MDBCardHeader, toast, ToastContainer, MDBCardBody, MDBContainer, MDBIcon, MDBBtn } from 'mdbreact';
import Header from '../Components/ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';
import _, { setWith } from 'lodash';

export default class CopaymentDetails extends React.Component {

    constructor(props) {
        super();
        this.dataLayer = new DataLayer();
        this.formatter = new Formatter();
        this.state = {
            copayments: [],
            tiers: []
        }
        this.addToCart = this.addToCart.bind(this);
        this.LoadCopayments = this.LoadCopayments.bind(this);
        this.RenderItemFooter = this.RenderItemFooter.bind(this);
    }

    async addToCart(item) {
        this.props.loaderOn();
        let response = await this.dataLayer.Post('/copayment/addcopaymenttocart', item, false);
        if (response.errorOccurred) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Error Occurred.</span>, {
                closeButton: false
            });
            this.props.loaderOff();
            //this.setState({ errorModalOpen: true, shopErrorMsg: response.errorMessage });
        } else {
            toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp;Item added successfully. </span>, {
                closeButton: false
            });
            this.props.updateCartCount(response.data);
            this.LoadCopayments();
        }


    }

    async componentDidMount() {
        this.props.loaderOn();
        this.LoadCopayments();
    }

    async LoadCopayments() {
        let coPaymentResult = await this.dataLayer.Get('/copayment/GetCopaymentProcessingItems', 200);
        this.setState({
            copayments: coPaymentResult.data
        });

        this.props.loaderOff();
    }

    RenderItemFooter(levelItem, tier, item, copaymentLevels) {
        const tierLevels = copaymentLevels.filter(lvl => lvl.coPaymentTier == tier.Tier);
        //const maxCanBuy = 

        if (levelItem.addedToCart) {
            if (levelItem.invQty > 0 && levelItem.orderQty > 0) {
                return (
                    <div>
                        <MDBRow>
                            <MDBCol>
                                <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>{levelItem.cartQty} Already Added To Cart</div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Already Added {levelItem.invQty} On Inv {levelItem.optInInvoiceId}</div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Already Added {levelItem.invQty} On Order {levelItem.optInOrderId}</div>
                            </MDBCol>
                        </MDBRow>
                    </div>
                )
            }
            if (levelItem.invQty > 0) {
                return (

                    <div>
                        <MDBRow>
                            <MDBCol>
                                <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>{levelItem.cartQty} Already Added To Cart</div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Already Added {levelItem.invQty} On Inv {levelItem.optInInvoiceId}</div>
                            </MDBCol>
                        </MDBRow>
                    </div>

                )
            }
            if (levelItem.orderQty > 0) {
                return (
                    <div>
                        <MDBRow>
                            <MDBCol>
                                <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>{levelItem.cartQty} Already Added To Cart</div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Already Added {levelItem.orderQty} On Order {levelItem.optInOrderId}</div>
                            </MDBCol>
                        </MDBRow>
                    </div>

                )
            }
            return (<div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>{levelItem.cartQty} Already Added To Cart</div>)
        }
        if (tier.alreadyOptedIn || tier.addedToCart) {
            if (levelItem.optInInvoiceId > 0) {
                if (levelItem.canBuy) {
                    if (levelItem.orderQty > 0) {
                        return (
                            <div>
                                <MDBRow>
                                    <MDBCol>
                                        <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Opted in for {levelItem.invQty} on Inv {levelItem.optInInvoiceId}</div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol>
                                        <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Opted in for {levelItem.orderQty} on Order {levelItem.optInOrderId}</div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol>
                                        <div style={{ textAlign: "center" }}>
                                            <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(levelItem)}>
                                                <MDBIcon icon="cart-plus" />
                                            </MDBBtn>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                        )
                    } else {
                        return (
                            <MDBRow>
                                <MDBCol>
                                    <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Opted in for {levelItem.invQty} on Inv {levelItem.optInInvoiceId}</div>
                                </MDBCol>
                                <MDBCol>
                                    <div style={{ textAlign: "center" }}>
                                        <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(levelItem)}>
                                            <MDBIcon icon="cart-plus" />
                                        </MDBBtn>
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        )
                    }
                } else {
                    if (levelItem.orderQty > 0) {
                        return (
                            <div>
                                <MDBRow>
                                    <MDBCol>
                                        <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Opted in for {levelItem.invQty} on Inv {levelItem.optInInvoiceId}</div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol>
                                        <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Opted in for {levelItem.orderQty} on Order {levelItem.optInOrderId}</div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                        )
                    } else {
                        return (
                            <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Opted in for {levelItem.invQty} on Inv {levelItem.optInInvoiceId}
                            </div>
                        )
                    }
                }
            }
            if (levelItem.optInOrderId > 0) {
                if (levelItem.canBuy) {
                    return (
                        <MDBRow>
                            <MDBCol><div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Opted in for {levelItem.orderQty} on Order {levelItem.optInOrderId}</div></MDBCol>
                            <MDBCol>
                                <div style={{ textAlign: "center" }}>
                                    <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(levelItem)}>
                                        <MDBIcon icon="cart-plus" />
                                    </MDBBtn>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    )
                } else {
                    return (<div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Opted in for {levelItem.orderQty} on Order {levelItem.optInOrderId}</div>)
                }
            }
            if (levelItem.qualified && item.orderingOpen) {
                if (levelItem.buyMultipleLevels && levelItem.canBuy) {
                    return (
                        <MDBRow>
                            <MDBCol>
                                <div style={{ textAlign: "center" }}>
                                    <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(levelItem)}>
                                        <MDBIcon icon="cart-plus" />
                                    </MDBBtn>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    )
                }
            }
            return (<div></div>);
        }
        if (levelItem.qualified && item.orderingOpen) {
            return (
                <MDBRow>
                    <MDBCol>
                        <div style={{ textAlign: "center" }}>
                            <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(levelItem)}>
                                <MDBIcon icon="cart-plus" />
                            </MDBBtn>
                        </div>
                    </MDBCol>
                </MDBRow>
            )
        }
        return (<div></div>)
        //{
        //    levelItem.addedToCart ? <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Already Added To Cart</div> :

        //        (tier.alreadyOptedIn || tier.addedToCart) ? (levelItem.OptInInvoiceId > 0) ?
        //            <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>Already Opted in on Inv {levelItem.OptInInvoiceId}</div> : <div></div> : levelItem.qualified ? item.orderingOpen ?
        //                <MDBRow>
        //                    <MDBCol>
        //                        <div style={{ textAlign: "center" }}>
        //                            <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(levelItem)}>
        //                                <MDBIcon icon="cart-plus" />
        //                            </MDBBtn>
        //                        </div>
        //                    </MDBCol>
        //                </MDBRow> : <div></div> : <div></div>
        //}
    }

    render() {
        return (
            <div>
                <Header headerText="Co-Payments"
                    hideSearch={true}
                    subHeaderText="(You are eligible for the copayments listed below)"
                />

                {this.state.copayments.map(item => {
                    var coPaymentTiers = [];
                    var qtyLeftForOptIn = 0;
                    item.copaymentLevels.map(lvl => {
                        var cpt = lvl.coPaymentTier;
                        var actionText = "(Choose 1)";

                        if (coPaymentTiers.find(el => el.Tier == lvl.coPaymentTier) === undefined) {
                            qtyLeftForOptIn = lvl.maxLevelsCanBuy;
                            if (lvl.buyMultipleLevels) {
                                if (lvl.alreadyOptedIn || lvl.addedToCart) {
                                    qtyLeftForOptIn--;
                                }
                                actionText = "(Already Opted In)";
                                if (qtyLeftForOptIn > 0) {
                                    actionText = "(Choose any " + qtyLeftForOptIn + ")";
                                }
                            } else {
                                if (lvl.alreadyOptedIn || lvl.addedToCart) {
                                    actionText = lvl.addedToCart ? "(Already Added To Cart)" : "(Already Opted In)"
                                }
                            }

                            switch (cpt) {
                                case "D":
                                    coPaymentTiers.push({ id: 1, alreadyOptedIn: lvl.alreadyOptedIn, addedToCart: lvl.addedToCart, Tier: cpt, Description: "Demonstrator Tier", Action: actionText }); //lvl.alreadyOptedIn ? "(Already Opted In)" : "(Choose One)" });
                                    break;
                                case 'M':
                                    coPaymentTiers.push({ id: 2, alreadyOptedIn: lvl.alreadyOptedIn, addedToCart: lvl.addedToCart, Tier: cpt, Description: "Manager Tier", Action: actionText }); //lvl.alreadyOptedIn ? "(Already Opted In)" : "(Choose One)" });
                                    break
                                case 'J':
                                    coPaymentTiers.push({ id: 3, alreadyOptedIn: lvl.alreadyOptedIn, addedToCart: lvl.addedToCart, Tier: cpt, Description: "Junior Manager Tier", Action: actionText }); //lvl.alreadyOptedIn ? "(Already Opted In)" : "(Choose One)" });
                                    break
                                case 'T':
                                    coPaymentTiers.push({ id: 4, alreadyOptedIn: lvl.alreadyOptedIn, addedToCart: lvl.addedToCart, Tier: cpt, Description: "Team Leader Tier", Action: actionText });//lvl.alreadyOptedIn ? "(Already Opted In)" : "(Choose One)" });
                                    break
                            }

                        } else {
                            var foundTier = coPaymentTiers.find(el => el.Tier == lvl.coPaymentTier);
                            if (lvl.buyMultipleLevels) {
                                if (lvl.alreadyOptedIn || lvl.addedToCart) {
                                    qtyLeftForOptIn--;
                                }
                                foundTier.Action = "(Already Opted In)";
                                if (qtyLeftForOptIn > 0) {
                                    foundTier.Action = "(Choose any " + qtyLeftForOptIn + ")";
                                }
                            }
                            if (lvl.alreadyOptedIn || lvl.addedToCart) {

                                foundTier.Action = lvl.addedToCart ? "(Already Added To Cart)" : "(Already Opted In)"
                                foundTier.alreadyOptedIn = lvl.alreadyOptedIn;
                                foundTier.addedToCart = lvl.addedToCart;

                            }


                        }
                    })
                    console.log("Tiers: ", coPaymentTiers);
                    return (


                        <MDBContainer style={{ marginTop: "9px" }} key={item.coPaymentId} fluid>
                            <span style={{ fontWeight: "bold" }}>{item.coPaymentDescription}: {item.orderingOpen ? <span>Ordering is Open</span> : <span>Ordering open from {item.orderingOpenFrom} - {item.orderingOpenTo}</span>}</span>
                            {coPaymentTiers.map(tier => {
                                return (
                                    <MDBCard style={{ marginTop: "1rem", marginBottom: "1rem" }} key={tier.id} fluid>
                                        <MDBCardHeader style={{ fontWeight: "bold" }}>{tier.Description + ' ' + tier.Action}</MDBCardHeader>
                                        <MDBCardBody style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                            <MDBRow>
                                                {item.copaymentLevels.map(levelItem => {
                                                    var imgUrl = levelItem.hasImage ? "https://tupp.tuppafrica.co.za/Images/virtualstore/" + levelItem.stockId + ".jpg" : "https://tupp.tuppafrica.co.za/images/virtualstore/noimage.png"
                                                    if (levelItem.coPaymentTier === tier.Tier) {
                                                        return (
                                                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r">
                                                                <MDBCard style={{ marginBottom: "9px", padding: "5px" }} key={levelItem.coPaymentLevelId}>
                                                                    <MDBRow>
                                                                        <MDBCol xl="8" lg="7" md="7" sm="8">
                                                                            <div style={{ fontWeight: "bold" }}>{levelItem.levelDescription}</div>
                                                                        </MDBCol>
                                                                        <MDBCol xl="4" lg="5" md="5" sm="4">
                                                                            <div className="right-side-meta" style={{ textAlign: "right" }}>Qualified&nbsp;{levelItem.qualified ? <MDBIcon style={{ fontSize: '17px' }} far icon="check-circle" className="green-text" /> : <MDBIcon style={{ fontSize: '17px' }} far icon="times-circle" className="red-text" />}</div>

                                                                        </MDBCol>
                                                                    </MDBRow>
                                                                    <MDBRow>
                                                                        <MDBCol>
                                                                            Qualify With {levelItem.kpiName} of {levelItem.formatNumber ? this.formatter.formatCurrency(levelItem.coPaymentLevelValue) : levelItem.coPaymentLevelValue}<br />
                                                                        </MDBCol>
                                                                    </MDBRow>
                                                                    <MDBRow>
                                                                        <MDBCol>
                                                                            You are currently on {levelItem.formatNumber ? this.formatter.formatCurrency(levelItem.currentKPILevelAchieved) : levelItem.currentKPILevelAchieved}
                                                                        </MDBCol>
                                                                    </MDBRow>
                                                                    <hr className="hr hr-blurry" />
                                                                    <MDBRow>
                                                                        <MDBCol>
                                                                            Opt in for:
                                                                        </MDBCol>
                                                                    </MDBRow>
                                                                    <MDBRow>
                                                                        <MDBCol>
                                                                            {levelItem.invoiceDescription}
                                                                        </MDBCol>
                                                                        <MDBCol>
                                                                            <img src={imgUrl} />
                                                                        </MDBCol>
                                                                    </MDBRow>
                                                                    <MDBRow>
                                                                        <MDBCol>
                                                                            <span style={{ fontWeight: 'bold' }}>Valued At: {this.formatter.formatCurrency(levelItem.valuedAt)}</span>
                                                                        </MDBCol>
                                                                    </MDBRow>
                                                                    <MDBRow>
                                                                        <MDBCol>
                                                                            Price: {this.formatter.formatCurrency(levelItem.price)}
                                                                        </MDBCol>
                                                                    </MDBRow>
                                                                    <hr />
                                                                    {this.RenderItemFooter(levelItem, tier, item, item.copaymentLevels)}



                                                                </MDBCard>
                                                            </MDBCol>
                                                        )
                                                    }
                                                })}
                                            </MDBRow>
                                        </MDBCardBody>
                                    </MDBCard>
                                )
                            })}
                            <hr className="hr hr-blurry" />
                        </MDBContainer>


                    )
                })}
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
}


//<MDBCard>
//    <MDBCardHeader>{item.coPaymentDescription}: {item.orderingOpen ? <span>Ordering is Open</span> : <span>Ordering open from {item.orderingOpenFrom} - {item.orderingOpenTo}</span>}</MDBCardHeader>
//    <MDBCardBody>
//        {coPaymentTiers.map(tier => {
//            var testTier = tier
//            return (
//                <div>
//                    <MDBRow>
//                        <MDBCol xl="4" lg="4" md="4" sm="4" className="mb-r" >
//                            {testTier.Description + ' ' + testTier.Action}
//                            {item.copaymentLevels.map(levelItem => {
//                                if (levelItem.coPaymentTier === testTier.Tier) {
//                                    return (
//                                        <div key={levelItem.coPaymentLevelId}>
//                                            <MDBRow>
//                                                <MDBCol xl="4" lg="4" md="4" sm="12" className="mb-r" >
//                                                    <MDBCard>
//                                                        <MDBCardText>
//                                                            <span style={{ fontWeight: "bold" }}>{levelItem.levelDescription}</span><br />
//                                                            Qualify With {levelItem.kpiName} of {levelItem.coPaymentLevelValue}<br />
//                                                            You are currently on {levelItem.currentKPILevelAchieved}
//                                                        </MDBCardText>
//                                                    </MDBCard>
//                                                </MDBCol>
//                                            </MDBRow>
//                                        </div>
//                                    )
//                                }
//                            })}
//                            {/*<hr className="hr hr-blurry" />*/}
//                        </MDBCol>
//                    </MDBRow>
//                </div>
//            )
//        })}





//    </MDBCardBody>

//</MDBCard>